import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { GlobalConstants } from '../common/global-constants';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private http: HttpClient, private sharedapi: SharedService) { }

  getHelpData(data) {
    let title = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl + 'get-help-data/' + title, { headers: webheader })
  }

  getHelpList(pageno, limit, qstring) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl + 'get-help-list/' + limit + '/' + pageno + '?' + qstring, { headers: webheader })
  }

  getHelpEditData(data) {
    let help_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl + 'get-update-help-data/' + help_id, { headers: webheader })
  }

  saveHelp(data) {

    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl + 'add-edit-help', data, { headers: webheader })
  }

}
